import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PostboxDocument } from 'cpes-common';
import { Combobox } from '@vwfs-bronson/bronson-react';
import { getListOfAvailableDocumentTypes, PostboxDocumentType } from '../../helper/DocumentType';
import { ComboboxState } from '../../../../types/bronson-react';
import { ComboboxOption } from '@cp-shared-19/frontend-ui';

export type DocumentTypeFilterProps = {
    postboxDocuments?: PostboxDocument[];
    onChange: (value: PostboxDocumentType) => void;
    initialValue?: PostboxDocumentType;
};

export const DocumentTypeFilter: React.FC<DocumentTypeFilterProps> = ({ postboxDocuments, onChange, initialValue }) => {
    const { t } = useTranslation('postbox');

    const availableOptionsWithTranslations = getListOfAvailableDocumentTypes(postboxDocuments || []).map(
        postboxDocument => ({
            ...postboxDocument,
            translation: t(`filters.document-type.select-items.${postboxDocument.translation}`),
        }),
    );

    const availableOptionElements = availableOptionsWithTranslations.map(postboxDocument => ({
        key: postboxDocument.type,
        value: {
            textValue: postboxDocument.translation as string,
            content: <div>{postboxDocument.translation}</div>,
        },
    }));

    const initialSelectedOption = availableOptionElements.find(option => option.key === initialValue);

    const [selectedItem, setSelectedItem] = useState<{ value: ComboboxOption[] }>({
        value: initialSelectedOption ? [(initialSelectedOption as unknown) as ComboboxOption] : [],
    });

    if (!postboxDocuments) {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectValueChange = (selected: any): void => {
        setSelectedItem({ value: [selected[0]] });
        onChange(selected[0].key as PostboxDocumentType);
    };

    const defaultOption =
        availableOptionsWithTranslations.find(option => option.type === initialValue) ||
        availableOptionsWithTranslations[0];

    const defaultItem: ComboboxState = {
        value: [
            {
                key: defaultOption.type,
                value: defaultOption.translation,
            },
        ],
    };

    return (
        <>
            <label>{t('filters.document-type.label')}</label>
            <Combobox
                className="c-form-field--no-floating"
                testId={'DocumentTypeFilter'}
                onChange={selectValueChange}
                value={selectedItem.value}
                options={availableOptionElements}
                defaultState={defaultItem}
            />
        </>
    );
};
